/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2021
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

define([], () => {
	class APISpec {
		getAPISpec() {
			if (!this.apiSpec){
				this.apiSpec = {
					name:'lasso API',
					events:{
						serializeActions: true,
						actions: {
							toggleLassoSelect: {
								eventName:'toggle',
								isTriggerEvent: () => true,
								getInfo:() => ({}),
								getAction:() => ({})
							}
						}
					}

				};
			}
			return this.apiSpec;
		}
	}
	return APISpec;
});
